import { render, staticRenderFns } from "./importBackupOrderModal.vue?vue&type=template&id=38891291&scoped=true"
import script from "./importBackupOrderModal.vue?vue&type=script&lang=js"
export * from "./importBackupOrderModal.vue?vue&type=script&lang=js"
import style0 from "./importBackupOrderModal.vue?vue&type=style&index=0&id=38891291&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38891291",
  null
  
)

export default component.exports